// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.problem {
  background: var(--bg-white);
}

.problem__head {
  text-align: left;
  margin-bottom: 48px;
}

.problem__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.problem__card {
  background: var(--bg-light);
  border-radius: var(--radius-md);
  padding: 28px 22px;
  border: 1px solid var(--border-soft);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.problem__card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-sm);
}

.problem__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 16px;
  color: var(--teal-dark);
  background: #fff;
  box-shadow: var(--shadow-sm);
  margin-bottom: 16px;
}

.problem__card h3 {
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 8px;
}

.problem__card p {
  font-size: 14px;
}

.problem__solution {
  margin-top: 60px;
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: 48px;
  background: linear-gradient(135deg, var(--ink-800), var(--ink-700));
  border-radius: var(--radius-xl);
  padding: 52px;
  align-items: center;
}

.problem__solution-copy h3 {
  color: #fff;
  font-size: 26px;
  font-weight: 800;
  margin-top: 14px;
}

.problem__solution-copy p {
  margin-top: 14px;
  color: rgba(255, 255, 255, 0.65);
  font-size: 15px;
}

.problem__solution-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.problem__solution-list li {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  color: rgba(255, 255, 255, 0.88);
  font-size: 15px;
  line-height: 1.6;
}

.problem__check {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--teal), var(--teal-dark));
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  margin-top: 2px;
}

@media (max-width: 980px) {
  .problem__grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .problem__solution {
    grid-template-columns: 1fr;
    padding: 36px 26px;
  }
}

@media (max-width: 560px) {
  .problem__grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Problem.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mEAAmE;EACnE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kEAAkE;EAClE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".problem {\n  background: var(--bg-white);\n}\n\n.problem__head {\n  text-align: left;\n  margin-bottom: 48px;\n}\n\n.problem__grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n\n.problem__card {\n  background: var(--bg-light);\n  border-radius: var(--radius-md);\n  padding: 28px 22px;\n  border: 1px solid var(--border-soft);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.problem__card:hover {\n  transform: translateY(-6px);\n  box-shadow: var(--shadow-sm);\n}\n\n.problem__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 16px;\n  color: var(--teal-dark);\n  background: #fff;\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 16px;\n}\n\n.problem__card h3 {\n  font-size: 17px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.problem__card p {\n  font-size: 14px;\n}\n\n.problem__solution {\n  margin-top: 60px;\n  display: grid;\n  grid-template-columns: 0.9fr 1.1fr;\n  gap: 48px;\n  background: linear-gradient(135deg, var(--ink-800), var(--ink-700));\n  border-radius: var(--radius-xl);\n  padding: 52px;\n  align-items: center;\n}\n\n.problem__solution-copy h3 {\n  color: #fff;\n  font-size: 26px;\n  font-weight: 800;\n  margin-top: 14px;\n}\n\n.problem__solution-copy p {\n  margin-top: 14px;\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 15px;\n}\n\n.problem__solution-list {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.problem__solution-list li {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n  color: rgba(255, 255, 255, 0.88);\n  font-size: 15px;\n  line-height: 1.6;\n}\n\n.problem__check {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--teal), var(--teal-dark));\n  color: #fff;\n  font-size: 12px;\n  font-weight: 800;\n  margin-top: 2px;\n}\n\n@media (max-width: 980px) {\n  .problem__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .problem__solution {\n    grid-template-columns: 1fr;\n    padding: 36px 26px;\n  }\n}\n\n@media (max-width: 560px) {\n  .problem__grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
